<div class="password-verification-modal" [class.d--hidden]="isLoading">
  <ng-container>
    <header class="modal__header">
      <h2>{{ content.verificationText.title }}</h2>
      <a class="button button--transparent modal__button--close" (click)="onCloseModal()">
        <i class="icon icon-ui-close--sm"></i>
      </a>
    </header>
    <div class="modal__content">
      <div class="modal__text" [internalInnerHtml]="content.verificationText.body" [userEventSource]="userEventSource"></div>
      <air-form #formComponent [controls]="form" [userEventSource]="userEventSource" (submitted)="submitValues($event)"> </air-form>
    </div>
    <div class="modal__footer--full-width-ends">
      <a
        class="button button--tertiary button--transparent"
        (click)="resendCode($event)"
        [airButtonLoading]="isResendLoading"
        [class.button--disabled]="isResendDisabled"
      >
        <span>{{ "account.label.resend_verification_code" | translate }}</span>
      </a>
      <a type="button" (click)="submit($event)" class="button form__button button--cta" [airButtonLoading]="isSubmitting">
        <span>{{ "account.label.verify" | translate }}</span>
      </a>
    </div>
  </ng-container>
</div>
